import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { CloseButton } from "~/components/AssetModalV2/Header/components/CloseButton";
import { useCloseAssetModal } from "~/components/AssetModalV2/hooks/useCloseAssetModal";
import { fileExtensionStylingMap, genericFile } from "~/components/FileExtensionPreview/types";
import { centralizedClipSelector } from "~/store/centralizedClip/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const FullscreenHeader = /*#__PURE__*/ memo((param)=>{
    let { navigationArrows } = param;
    const store = useAirStore();
    const clip = centralizedClipSelector(store.getState());
    const { closeAssetModal } = useCloseAssetModal({
        trackLocation: "fullscreen-header-close-button"
    });
    const { iconComponent: IconComponent } = useMemo(()=>{
        var _clip_ext;
        const normalizedExt = (clip === null || clip === void 0 ? void 0 : (_clip_ext = clip.ext) === null || _clip_ext === void 0 ? void 0 : _clip_ext.toLowerCase()) || "";
        return normalizedExt in fileExtensionStylingMap ? fileExtensionStylingMap[normalizedExt] : genericFile;
    }, [
        clip === null || clip === void 0 ? void 0 : clip.ext
    ]);
    var _clip_title, _ref;
    return /*#__PURE__*/ _jsxs("div", {
        className: "pointer-events-auto relative flex w-full items-center justify-between gap-2 rounded-8 bg-black/80 px-5 py-3 text-white backdrop-blur",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(IconComponent, {
                        className: "size-4 text-current"
                    }),
                    (_ref = (_clip_title = clip.title) !== null && _clip_title !== void 0 ? _clip_title : clip.importedName) !== null && _ref !== void 0 ? _ref : "Untitled"
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-end gap-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: navigationArrows
                    }),
                    /*#__PURE__*/ _jsx(CloseButton, {
                        onClose: closeAssetModal
                    })
                ]
            })
        ]
    });
});
FullscreenHeader.displayName = "FullscreenHeader";
